module.exports = __webpack_public_path__ + "img/W6.3cd1bc3a.png";